import Icon, { IconType } from 'components/Icon';
import { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'redux/db/reducers';
import { showDownloadsModal } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';

const DownloadsMenuItem = () => {
	const theme = useTheme();
	const dispatch = useDispatch();

	const { recentExports } = useSelector(
		(r: RootReducer) => ({
			recentExports: selectUser(r.db)?.metadata?.recentExports ?? [],
		}),
		shallowEqual
	);
	const hasUnviewed = useMemo(() => recentExports.some((e) => !e.downloadedAt), [recentExports]);

	if (recentExports.length === 0) return null;

	return (
		<S.Item onSelect={() => dispatch(showDownloadsModal())}>
			<Icon type={IconType.DOWNLOAD} width={14} height={14} color={theme.gray[900]} />
			View downloads
			{hasUnviewed && <S.Dot />}
		</S.Item>
	);
};

export default DownloadsMenuItem;
